import axios from 'axios';
import type { Crianca, LivroHeroBook, Presentation, Tracos } from '../../services/livro-customizado.service';

/** Livro montado e salvo no Hero Book — o que o pagamento precisa. */
export interface LivroPronto {
  draftId: string;
  draftKey: string;
  bookId: string;
  titulo: string;
  nomeCrianca: string;
}

export type Etapa = 'livro' | 'personagem' | 'nome' | 'previa';

export interface Rascunho {
  draftId: string;
  draftKey: string;
  livro: LivroHeroBook;
  presentation: Presentation;
  tracos: Tracos;
  crianca: Crianca | null;
  etapa: Etapa;
  salvoEm: number;
}

const CHAVE_STORAGE = 'livro-customizado:rascunho:v1';
/** O rascunho expira em 7 dias no Hero Book; retoma só até 6. */
const VALIDADE_RASCUNHO_MS = 6 * 24 * 60 * 60 * 1000;

export function lerRascunho(): Rascunho | null {
  try {
    const bruto = window.localStorage.getItem(CHAVE_STORAGE);
    if (!bruto) return null;
    const r = JSON.parse(bruto) as Rascunho;
    if (!r?.draftId || !r?.draftKey || Date.now() - (r.salvoEm ?? 0) > VALIDADE_RASCUNHO_MS) return null;
    return r;
  } catch {
    return null;
  }
}

export function gravarRascunho(r: Rascunho | null) {
  try {
    if (r) window.localStorage.setItem(CHAVE_STORAGE, JSON.stringify({ ...r, salvoEm: Date.now() }));
    else window.localStorage.removeItem(CHAVE_STORAGE);
  } catch {
    /* storage indisponível (aba anônima): segue sem retomar */
  }
}

export function limparRascunhoSalvo() {
  gravarRascunho(null);
}

export const MSG_RASCUNHO_VENCIDO = 'Seu livro expirou, monte de novo.';

/**
 * 410 da API (`reason: rascunho_expirado`): o rascunho venceu no Hero Book e o
 * salvo no navegador não serve mais. Olha o status porque a página da prévia
 * vem como blob (sem `reason` legível).
 */
export function rascunhoVencido(err: unknown): boolean {
  if (!axios.isAxiosError(err)) return false;
  const reason = (err.response?.data as { reason?: unknown } | undefined)?.reason;
  return err.response?.status === 410 || reason === 'rascunho_expirado';
}
